import Select from "react-select";

export function CatalogProductSelector({
  catalogProducts,
  selectedCatalogProduct,
  handleSelectedCatalogProducts,
}: {
  catalogProducts: any[];
  selectedCatalogProduct: any[];
  handleSelectedCatalogProducts: (val: any) => void;
}) {
  return (
    <div>
      <div className="flex-1 min-w-0 mt-4">
        <p>Select Products</p>
      </div>
      <div className="mt-1 space-y-8">
        <Select
          isMulti
          isSearchable
          name="catalogProducts"
          options={catalogProducts}
          value={selectedCatalogProduct}
          className="basic-multi-select"
          classNamePrefix="select"
          onChange={handleSelectedCatalogProducts}
        />
      </div>
    </div>
  );
}
